import { twMerge } from 'tailwind-merge';
import { PRODUCT } from '@/constants/product';
import Card from '@/components/Card';
import { classes } from './utils';

export interface ProductCardProps {
  className?: string;
}

export default function ProductCard({ className }: ProductCardProps) {
  return (
    <Card className={twMerge(classes.card, className)}>
      <div className={classes.imageColumn}>
        <div className={classes.imageWell}>
          <img
            src={PRODUCT.imageSrc}
            alt={PRODUCT.imageAlt}
            className={classes.image}
          />
        </div>
      </div>
      <div className={classes.copyColumn}>
        <div>
          <div className={classes.eyebrow}>{PRODUCT.eyebrow}</div>
          <h1 className={classes.title}>{PRODUCT.name}</h1>
          <div className={classes.subtitle}>{PRODUCT.subtitle}</div>
        </div>
        <p className={classes.description}>{PRODUCT.description}</p>
        <div className={classes.pills}>
          {PRODUCT.inStock && (
            <span className={classes.pillStock}>In stock</span>
          )}
          <span className={classes.pill}>Free EU shipping</span>
        </div>
      </div>
    </Card>
  );
}
